import "../../Styles/searchbar.css";
import { PiCardsFill } from "react-icons/pi";
import { FaListUl } from "react-icons/fa";


const SearchBar = ({
  selected,
  categoryData,
  locationData,
  setSelected,
  keyword,
  setKeyword,
  propertyTypeId,
  setPropertyTypeId,
  setPropertyType,
  locationId,
  setLocationId,
  setLocation,
  handleSearch,
  setPriceRange,
  priceRange
}) => {
  return (
    <>
      <section className="searchbar-section">
        <div className="container py-5 ">
          <div className="row search-bar py-4 align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3 position-relative">
              <div className="position-relative ">
                <input
                  type="text"
                  className="form-control search-input"
                  id="keyword"
                  placeholder="Search"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </div>
            </div>

            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-9 property-col">
              <div className="search-bar-inner">
                <label
                  htmlFor="propertyType"
                  className="form-label search-label"
                >
                  Property Type
                </label>
                <select
                  className="form-select search-select"
                  id="propertyType"
                  onChange={(e) => {
                    const selectedOption =
                      e.target.options[e.target.selectedIndex];
                    const selectedKey = selectedOption.getAttribute("data-key");
                    setPropertyType(e.target.value);
                    setPropertyTypeId(selectedKey);
                  }}
                >
                  <option value="">Select type</option>
                  {categoryData && categoryData.map((data) => {
                    return (
                      <option key={data.id} value={data.slug} data-key={data.id} selected={data.id == propertyTypeId}>
                        {data.category_name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="search-bar-inner">
                <label htmlFor="Location" className="form-label search-label">
                  Location
                </label>
                <select className="form-select search-select" id="locate" onChange={(e) => {
                  const selectedOption =
                    e.target.options[e.target.selectedIndex];
                  const selectedKey = selectedOption.getAttribute("data-key");
                  setLocation(e.target.value);
                  setLocationId(selectedKey);
                }}>
                  <option value="">Select location</option>
                  {
                    locationData && locationData?.map((item, i) => (
                      <option key={item.id} value={item.slug} data-key={item.id} selected={item.id == locationId}>{item.city}</option>
                    ))
                  }
                </select>
              </div>
              <div className="search-bar-inner">
                <label
                  htmlFor="PrinceRange"
                  className="form-label search-label"
                >
                  Price Range
                </label>
                <select className="form-select search-select" id="locate" onChange={(e) => setPriceRange(e.target.value)}>
                  <option value="">Select range</option>
                  <option value={"low-to-high"} selected={priceRange === "low-to-high"}>Low to High</option>
                  <option value={"high-to-low"} selected={priceRange === "high-to-low"}>High to Low</option>
                </select>
              </div>

              <button
                type="button"
                className="btn btn-primary btn-block search-btn"
                onClick={() => handleSearch()}
              >
                Search
              </button>

              <div className="search-bar-btn">
                <button
                  type="button"
                  className={`search-bar-btn-1 ${selected === "card" ? "active" : ""
                    }`}
                  onClick={() => setSelected("card")}
                >
                  <PiCardsFill />
                </button>
                <button
                  type="button"
                  className={`search-bar-btn-1 ${selected === "list" ? "active" : ""
                    }`}
                  onClick={() => setSelected("list")}
                >
                  <FaListUl />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SearchBar;
